import packages from '../package.json'

import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import * as featureFlagsActions from 'services/FeatureFlags/actions'

import React from 'react'
import { createRoot, hydrateRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { Router } from 'react-router-dom'

import 'shared-global-ec-uikit/components/dist/css/main.global.css'
import 'shared-global-ec-uikit/components/dist/css/main.fonts.css'
import 'shared-global-ec-uikit/components/dist/css/main.css'
//import 'shared-global-ec-uikit/components/dist/css/variables.css'

// # Import polyfills for react-intl(IntlContainer)
import '@formatjs/intl-locale/polyfill' // ! Import this polyfill before pluralrules
import '@formatjs/intl-pluralrules/polyfill'

import * as serviceWorker from 'serviceWorker'
import * as localisationActions from 'services/Localisation/actions'

import createStore from 'createStore'
import history from 'browserHistory'

import AppLayout from 'containers/AppLayout'
import Intl from 'containers/Intl'
import Pages from 'pages'

import 'react-app-polyfill/ie11'
import getConstants from './constants'
import { canUseDOM } from './utils'
import { initFocusVisible } from './utils/focusVisible'
import TagManager from 'react-gtm-module'
import { initFirebaseRemoteConfig } from 'helpers/featureFlags'
import { BRAND_LIST, Countries, FeatureFlags } from 'typings'

const tagManagerArgs = {
  gtmId: process.env.REACT_APP_GTM_CONTAINER_ID as string,
}

document
  .querySelector<HTMLInputElement>('html')!
  .setAttribute('lang', getConstants().LANGUAGE)

initFocusVisible()

const store = createStore()

TagManager.initialize(tagManagerArgs)

const App = (
  <Provider store={store}>
    <Intl>
      <Router history={history}>
        <AppLayout>
          <Pages />
        </AppLayout>
      </Router>
    </Intl>
  </Provider>
)

const rootEl = document.getElementById('root')

let root = createRoot(rootEl as HTMLElement)

if (rootEl && rootEl.hasChildNodes()) {
  hydrateRoot(rootEl, App)
} else {
  root.render(App)
}

if ((module as any).hot) {
  ;(module as any).hot.accept('./containers/AppLayout', () => {
    const NextApp = require('./containers/AppLayout').default
    root.render(<NextApp />)
  })
}

let wordingVersion = ''

if (packages.dependencies && packages.dependencies['excel-to-json-test']) {
  wordingVersion = packages.dependencies['excel-to-json-test']
    .split('#')[1]
    .replace('v', '')
}

if (canUseDOM) {
  ;(window as any).__LOCALISATION_VERSION__ = wordingVersion
  ;(window as any).__CANARY__ = process.env.CANARY
  ;(window as any).__ENV__ = process.env.REACT_APP_ENV
  if (
    process.env.REACT_APP_ENV === 'staging' ||
    process.env.REACT_APP_ENV === 'development'
  ) {
    ;(window as any).toggleLIDs = () => {
      store.dispatch(localisationActions.toggleLID())
    }
  }
}

const onFeatureFlagsLoad = (featureFlags: FeatureFlags) => {
  store.dispatch(featureFlagsActions.setFeatureFlags(featureFlags))
  store.dispatch(featureFlagsActions.setFeatureFlagsLoaded())
  store.dispatch(
    localisationActions.checkLocalisationUpdate(
      getConstants().COUNTRY,
      featureFlags,
      wordingVersion,
    ),
  )
}

// add extra check because this can cause issue in local development when FIREBASE key is missing
if (process.env) {
  if (process.env.REACT_APP_FIREBASE_API_KEY) {
    initFirebaseRemoteConfig(
      {
        apiKey: process.env.REACT_APP_FIREBASE_API_KEY as string,
        authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN as string,
        projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID as string,
        storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET as string,
        messagingSenderId: process.env
          .REACT_APP_FIREBASE_MESSAGING_SENDER_ID as string,
        appId: process.env.REACT_APP_FIREBASE_WEB_APP_ID as string,
      },
      getConstants().BRAND as BRAND_LIST,
      getConstants().COUNTRY as Countries,
      onFeatureFlagsLoad,
    )
  }
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
